<template>
  <DsFeaturesSection
    title-base="Características"
    title-highlight="generales"
    title-id="avaluos-features-title"
    :features="features"
    class="avaluos-features"
  />
</template>

<script setup lang="ts">
import deliveryTimeIcon from '../../../../../assets/avaluos/avaluos-delivery-time.svg'
import propertyValueIcon from '../../../../../assets/avaluos/avaluos-property-value.svg'
import validityIcon from '../../../../../assets/avaluos/avaluos-validity.svg'
import DsFeaturesSection from '../components/DsFeaturesSection.vue'

const features = [
  {
    id: 'property-value',
    iconSrc: propertyValueIcon,
    title: '¿Qué es y para qué sirve?',
    description:
      'Es un documento que establece el valor de un bien inmueble a partir ' +
      'de sus características físicas, ubicación y uso, así como de una ' +
      'investigación y análisis de mercado.'
  },
  {
    id: 'validity',
    iconSrc: validityIcon,
    title: 'Vigencia',
    description:
      'Tiene una vigencia de 6 meses a partir de la fecha de emisión, por ' +
      'lo que es importante realizarlo de manera oportuna.'
  },
  {
    id: 'delivery-time',
    iconSrc: deliveryTimeIcon,
    title: 'Plazo de entrega',
    description:
      'En un máximo de 9 días hábiles tendrás tu avalúo listo y enviado a ' +
      'tu correo electrónico.',
    descriptionHtml:
      'En un máximo de <strong>9 días hábiles</strong> tendrás tu avalúo ' +
      'listo y enviado a tu correo electrónico.'
  }
]
</script>

<style scoped>
@media (min-width: 768px) {
  .avaluos-features :deep(.ds-feature-card) {
    min-height: 248px;
  }
}

@media (min-width: 1208px) {
  .avaluos-features :deep(.ds-feature-card) {
    min-height: 272px;
  }
}
</style>
